module.exports = __webpack_public_path__ + "img/vertical-logo.b6138125.svg";